<template>
    <div class="myTicket">
        <van-tabs v-model="active" @change="tabChange">
            <van-tab name="myIndent">
                <div slot="title" class="title">
                    我的票券
                </div>
                <div class="indentList">
                    <van-pull-refresh v-model="list1IsLoading" @refresh="list1OnRefresh">
                        <van-list v-model="list1Loading" :finished="list1Finished" @load="list1OnLoad">
                            <div class="item" v-for="(item, index) in list1" :key="index">
                                <!-- <div class="titleBox">
                                    <p class="left">{{item.ticketname}} x {{item.ticketnum}}</p>
                                    <p class="right">￥{{item.finalpaymoney}}</p>
                                </div>
                                <p>订单编号：{{item.orderno}}</p>
                                <p>订单时间：{{item.datetime}}</p>
                                <p>订单状态：<span :class="{'status1': item.status === 1, 'status3': item.status === 3, 'status9': item.status === 9, 'status10': item.status === 10 || item.status === 30,}">{{item.statusname}}</span></p>
                                <div class="division">
                                    <div class="line"></div>
                                    <div class="left"></div>
                                    <div class="right"></div>
                                </div>
                                <div class="btnBox">
                                    <van-button type="default" class="cancel" v-if="item.status === 9 || item.status === 1" @click="cancelOrder(item, index)">取消订单</van-button>
                                    <van-button type="default" class="payment" v-if="item.status === 9" @click="immediatelyPay(item)">立即付款</van-button>
                                    <van-button type="default" class="checkTicket" v-if="item.status !== 9 && item.status !== 100" @click="checkTicket(item)">查看票券</van-button>
                                    <van-button type="default" class="anewPay" v-if="item.status === 100" @click="replaceBuy">重新购买</van-button>
                                </div> -->
                                <div class="eventMsg">
                                    <div class="left">
                                        <img :src="item.coveratturlid" alt="">
                                    </div>
                                    <div class="right">{{item.title}}</div>
                                </div>
                                <div class="line">
                                    <div class="circle1"></div>
                                    <div class="dotted_line"></div>
                                    <div class="circle2"></div>
                                </div>
                                <div class="ticketBtn">
                                    <div class="left">
                                        {{item.ticketname}}
                                        <span>x{{item.ticketcount}}</span>
                                    </div>
                                    <div class="right">
                                        <van-button @click="checkTicket(item)">查看票券</van-button>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                        <div class="noData" v-if="!list1.length">
                            <img :src="require('@/common/images/activeTools/noData.png')" alt="">
                        </div>
                    </van-pull-refresh>
                </div>
            </van-tab>
            <van-tab name="getTicket">
                <div slot="title" class="title">
                    领取的票券
                </div>
                <div class="getTicket">
                    <van-pull-refresh v-model="list2IsLoading" @refresh="list2OnRefresh">
                        <van-list v-model="list2Loading" :finished="list2Finished" @load="list2OnLoad">
                            <div class="item" v-for="(item, index) in list2" :key="index">
                                <!-- <p class="ticketName">{{item.ticketname}}</p>
                                <div class="participant">
                                    <p class="leftTitle">参加人：</p>
                                    <div class="rightList">
                                        <div class="rightListItem" v-for="(obj, i) in item.joinlist" :key="i">
                                            <p class="name">{{obj.joinername}}</p>
                                            <p class="number">{{obj.joinermobile}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="ticketNum">
                                    <p class="leftTitle">票号：</p>
                                    <div class="rightList">
                                        <div class="rightListItem" v-for="(obj, i) in item.ticketnolist" :key="i">
                                            <p class="num">{{obj.ticketno}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="statusIcon">
                                    <img :src="require('@/common/images/activeTools/ticket_status05.png')" v-if="item.signstatus === 0" alt="">
                                    <img :src="require('@/common/images/activeTools/ticket_status01.png')" v-if="item.signstatus === 1" alt="">
                                </div> -->
                                <div class="eventMsg">
                                    <div class="left">
                                        <img :src="item.coveratturlid" alt="">
                                    </div>
                                    <div class="right">{{item.title}}</div>
                                </div>
                                <div class="line">
                                    <div class="circle1"></div>
                                    <div class="dotted_line"></div>
                                    <div class="circle2"></div>
                                </div>
                                <div class="ticketBtn">
                                    <div class="left">
                                        {{item.ticketname}}
                                        <span>x{{item.ticketcount}}</span>
                                    </div>
                                    <div class="right">
                                        <van-button @click="checkGetTicket(item)">查看票券</van-button>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                        <div class="noData" v-if="!list2.length">
                            <img :src="require('@/common/images/activeTools/noData.png')" alt="">
                        </div>
                    </van-pull-refresh>
                </div>
            </van-tab>
        </van-tabs>
        <!-- <p class="checkMsg" @click="checkAtyMsg">查看活动详情</p> -->
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import {cancelEventOrder, getOrderPayUrl} from 'api/activeTools'
import {getEventGettedTickets, getMyEventTickets} from 'api/activeMy'
export default {
    name: 'myTicket',
    data() {
        return {
            active: 'myIndent',
            list1: [],
            list2: [],
            list1IsLoading: false,
            list1Loading: false,
            list1Finished: false,
            list2IsLoading: false,
            list2Loading: false,
            list2Finished: false,
            list1Page: {
                page: 1,
                pageSize: 10,
                resulttype: 1
            },
            list2Page: {
                page: 1,
                pageSize: 10,
                resulttype: 2
            },
            eventid: this.$route.query.eventid,
            request: false,
            show: false,
        }
    },
    mounted() {
        document.title = '我的票券'
    },
    beforeRouteEnter (to, from, next) {
        if (from.name === 'getTicket' || from.name === 'AaSginUpAdd' || from.name === 'getTicketDetails') {
            next((v) => {
                v.active = 'getTicket'
            })
        } else {
            next()
        }
    },
    methods: {

        checkGetTicket(item) {
            this.$router.push({name: 'MyGetTicDet', query: {eventid: item.eventid, itemid: item.itemid}})
        },
        getMyEventTickets() {
            let options = {
                page: this.list1Page.page,
                pageSize: this.list1Page.pageSize
            }
            this.setLoading(true)
            getMyEventTickets({
                data: options,
                success: res => {
                    this.request = false
                    this.setLoading(false)
                    this.list1IsLoading = false
                    this.list1Loading = false
                    this.list1Page.page = ++this.list1Page.page
                    if (options.page === 1) {
                            this.list1 = res.data.content
                        } else {
                            this.list1 = this.list1.concat(res.data.content)
                        }
                        if (this.list1.length >= res.data.pageinfo.rowCount) {
                            this.list1Finished = true
                        }
                    console.log(res)

                },
                error: res => {
                    this.setLoading(false)
                    this.list1IsLoading = false
                    this.list1Loading = false
                    this.list1Finished = true
                    this.$toast.fail(res.msg)
                }
            })
        },
        checkAtyMsg() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        // 立即付款
        immediatelyPay(item) {
            this.setLoading(true)
            getOrderPayUrl({
                data: {orderno: item.orderno},
                success: data => {
                    this.setLoading(false)
                    window.location.href = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        tabChange(name) {
            if (name === 'getTicket') {
                if (this.list2.length === 0) {
                    this.list2Page.page = 1
                    this.request = true
                    this.getEventGettedTickets()
                }
            } else if (name === 'myIndent') {
                if (this.list1.length === 0) {
                    this.list1Page.page = 1
                    this.request = true
                    this.getMyEventTickets()
                }
            }
        },
        list1OnRefresh() {
            this.list1Finished = false
            this.list1Page.page = 1
            this.list1 = []
            this.request = true
            this.getMyEventTickets()
        },
        list1OnLoad() {
            if (!this.request && !this.list1Finished) {
                this.getMyEventTickets()
            }
        },
        list2OnRefresh() {
            this.list2Finished = false
            this.list2Page.page = 1
            this.list2 = []
            this.request = true
            this.getEventGettedTickets()
        },
        list2OnLoad() {
            if (!this.request && !this.list2Finished) {
                this.getEventGettedTickets()
            }
        },
        // 获取票券列表
        getEventGettedTickets() {
            this.setLoading(true)
            let options = {}
            if (this.active === 'myIndent') {
                options = this.list1Page
            } else {
                options = this.list2Page
            }
            getEventGettedTickets({
                data: options,
                success: data => {
                    this.setLoading(false)
                    // if (this.active === 'myIndent') {
                    //     this.list1IsLoading = false
                    //     this.list1Loading = false
                    //     this.list1Page.page = ++this.list1Page.page
                    //     if (options.page === 1) {
                    //         this.list1 = data.data.content
                    //     } else {
                    //         this.list1 = this.list1.concat(data.data.content)
                    //     }
                    //     if (this.list1.length >= data.data.pageinfo.rowCount) {
                    //         this.list1Finished = true
                    //     }
                    // } else {
                        this.list2IsLoading = false
                        this.list2Loading = false
                        this.list2Page.page = ++this.list2Page.page
                        if (options.page === 1) {
                            this.list2 = data.data.content
                        } else {
                            this.list2 = this.list2.concat(data.data.content)
                        }
                        if (this.list2.length >= data.data.pageinfo.rowCount) {
                            this.list2Finished = true
                        }
                        console.log(this.list2IsLoading, this.list2Loading, this.list2Finished)
                    // }
                    // this.getIsLoading = false
                    // this.getLoading = false
                    // if (this.getPage.page === 1) {
                    //     this.list2 = []
                    // }
                    // data.data.ticketlist.forEach(obj => {
                    //     // obj.status = 100
                    //     this.list2.push(obj)
                    // })
                    this.request = false
                    // this.getNum = data.data.splitPage.rowCount
                    // if (data.data.splitPage.rowCount <= this.list2.length) {
                    //     this.getFinished = true
                    // } else {
                    //     this.getPage.page++
                    // }
                },
                error: data => {
                    this.setLoading(false)
                    this.list2IsLoading = false
                    this.list2Loading = false
                    this.list2Finished = true
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 取消订单
        cancelOrder(item, index) {
            this.$dialog.confirm({
                title: '确认取消订单吗？'
            }).then(() => {
                this.setLoading(true)
                cancelEventOrder({
                    data: {orderno: item.orderno},
                    success: () => {
                        this.setLoading(false)
                        this.list1[index].status = 100
                        this.list1[index].statusname = '已取消'
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            }).catch(() => {

            })
        },
        // 重新购买
        replaceBuy() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        // 领取的票券详情
        checkGetTicketMsg(item) {
            this.$router.push({name: 'getTicketDetails', query: {eventid: this.eventid, itemid: item.itemid}})
        },
        // 查看票券详情
        checkTicket(item) {
            this.$router.push({name: 'ticketDetails', query: {orderno: item.orderno, eventid: item.eventid}})
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    #app {
        height: 100%;
    }
    .myTicket{
        height: 100%;
        // overflow: hidden;
        display: flex;
        flex-direction: column;
        .van-tabs{
            // height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: scroll;
            .van-tabs__wrap{
                height: 1rem;
                width: 100%;
                overflow: visible;
                position: fixed;
                top: 0;
                z-index: 1000;
                .van-tabs__nav{
                    padding-bottom: 0;
                    .van-tabs__line{
                        bottom: 0.1rem;
                    }
                    .van-tab{
                        .van-ellipsis{
                            color: #333333;
                            .title{
                                height: 1rem;
                                line-height: 1rem;
                                font-size: 0.3rem;
                                font-weight: 550;
                            }
                        }
                    }
                    .van-tab--active{
                        .van-tab__text--ellipsis{
                            .title {
                                color: #409EFF;
                                font-weight: bold;
                                font-size: 0.3rem;
                            }
                        }
                    }
                    .van-tabs__line{
                        background: #409EFF;
                        line-height: 0.04rem;
                    }
                }
            }
            .van-tabs__content{
                flex:1;
                padding-top: 1rem;
                .van-tab__pane{
                    height: 100%;
                }
                .indentList{
                    padding: 0.32rem 0.32rem 0rem;
                    background: #F5F7FA;
                    height: 100%;
                    box-sizing: border-box;
                    .van-pull-refresh{
                        height: 100%;
                        // overflow: scroll;
                    }
                    .van-list:not(:last-child){
                        margin-bottom: 0.32rem;
                    }
                    .item{
                        background: #fff;
                        box-shadow:0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
                        // padding: 0.28rem 0.32rem 0.2rem;
                        border-radius: 0.1rem;
                        &:not(:last-of-type){
                            margin-bottom: 0.32rem;
                        }
                        .titleBox{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 0.28rem;
                            padding-bottom: 0.28rem;
                            p{
                                font-weight: 550;
                            }
                        }
                        &>p{
                            line-height: 0.38rem;
                            margin-bottom: 0.12rem;
                            color: #999999;
                            font-size: 0.26rem;
                            .status1{
                                color: #FFA904;
                            }
                            .status9{
                                color: #FF4747;
                            }
                            .status10{
                                color: #0ABF53;
                            }
                            .status3{
                                color: #FF4747;
                            }
                        }
                        .division{
                            position: relative;
                            .line{
                                border-bottom: 0.02rem dashed #999999;
                            }
                            .left,.right{
                                width: 0.15rem;
                                height: 0.3rem;
                                position: absolute;
                                background: #F5F7FA;
                                // background: red;
                                // border-radius: 0.2rem 0.2rem 0 0;
                            }
                            .left{
                                border-radius: 0rem 0.15rem 0.15rem 0;
                                left: -0.34rem;
                                top: -0.15rem;
                            }
                            .right{
                                right: -0.34rem;
                                top: -0.15rem;
                                border-radius: 0.15rem 0 0 0.15rem;
                            }
                        }
                        .btnBox{
                            padding-top: 0.2rem;
                            text-align: right;
                            .van-button{
                                margin-left: 0.32rem;
                                width: 1.58rem;
                                height: 0.58rem;
                                border-radius: 0.08rem;
                                padding: 0;
                                line-height: 0.58rem;
                                background: #0ABF53;
                                color: #fff;
                                font-size: 0.24rem;
                            }
                            .cancel{
                                background: transparent;
                                color: #0ABF53;
                                border: 0.01rem solid rgba(10,191,83,1);
                            }
                        }
                        .eventMsg {
                            display: flex;
                            padding: 0.32rem 0.2rem;
                            .left {
                                img {
                                    width: 1.8rem;
                                    height: 1rem;
                                    margin-right: 0.2rem;
                                }
                            }
                            .right {
                                font-size: 0.26rem;
                                text-overflow: -o-ellipsis-lastline;
                                font-weight: bold;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                line-clamp: 3;
                                -webkit-box-orient: vertical;
                                line-height: 0.34rem;
                            }
                        }
                        .line {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-bottom: 0.2rem;
                            .dotted_line {
                                width: 6.22rem;
                                // height: 0.01rem;
                                border-bottom: 0.02rem dotted #E5E5E5;
                            }
                            .circle1 {
                                width: 0.15rem;
                                height: 0.3rem;
                                background: #F5F7FA;
                                border-radius: 0rem 0.15rem 0.15rem 0;
                            }
                            .circle2 {
                                width: 0.15rem;
                                height: 0.3rem;
                                background: #F5F7FA;
                                border-radius: 0.15rem 0 0 0.15rem;
                            }
                        }
                        .ticketBtn {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 0.32rem 0.32rem;
                            .left {
                                font-size: 0.26rem;
                                color: #333333;
                                span {
                                    margin-left: 0.2rem;
                                    font-size: 0.26rem;
                                    color: #999999;
                                }
                            }
                            .right {
                                button {
                                    width: 1.58rem;
                                    height: 0.5rem;
                                    background: #409EFF;
                                    color: #fff;
                                    border-radius: 0.3rem;
                                    padding: 0;
                                    font-size: 0.24rem;
                                    line-height: 0.5rem;
                                }
                            }
                        }
                    }
                }
                .getTicket{
                    padding: 0.32rem 0.32rem 0.32rem;
                    background: #F5F7FA;
                    height: 100%;
                    box-sizing: border-box;
                    .van-pull-refresh{
                        height: 100%;
                        // overflow: scroll;
                    }
                    .item{
                        background: #fff;
                        box-shadow:0px 0px 0.06rem 0px rgba(0,0,0,0.1);
                        border-radius: 0.1rem;
                        // padding: 0.32rem;
                        margin-bottom: 0.32rem;
                        position: relative;
                        .ticketName{
                            font-size: 0.28rem;
                            font-weight: 550;
                            line-height: 0.4rem;
                        }
                        .participant, .ticketNum{
                            padding-top: 0.28rem;
                            display: flex;
                            // align-items: center;
                            color: #666666;
                            font-size: 0.28rem;
                            .leftTitle{
                                width: 1.2rem;
                                text-align: left;
                            }
                            .rightList{
                                .rightListItem{
                                    p{
                                        line-height: 0.38rem;
                                    }
                                    display: flex;
                                    .name{
                                        width: 1rem;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        overflow: hidden;
                                        margin-right: 0.3rem;
                                    }
                                }
                            }
                        }
                        .ticketNum{
                            padding-top: 0.12rem;
                        }
                        .statusIcon{
                            position: absolute;
                            right: 0;
                            top: 0;
                            img{
                                width: 0.9rem;
                                height: 0.9rem;
                            }
                        }
                        .eventMsg {
                            display: flex;
                            padding: 0.32rem 0.2rem;
                            .left {
                                img {
                                    width: 1.8rem;
                                    height: 1rem;
                                    margin-right: 0.2rem;
                                }
                            }
                            .right {
                                font-size: 0.26rem;
                                text-overflow: -o-ellipsis-lastline;
                                font-weight: bold;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                line-clamp: 3;
                                -webkit-box-orient: vertical;
                                line-height: 0.34rem;
                            }
                        }
                        .line {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-bottom: 0.2rem;
                            .dotted_line {
                                width: 6.22rem;
                                // height: 0.01rem;
                                border-bottom: 0.02rem dotted #E5E5E5;
                            }
                            .circle1 {
                                width: 0.15rem;
                                height: 0.3rem;
                                background: #F5F7FA;
                                border-radius: 0rem 0.15rem 0.15rem 0;
                            }
                            .circle2 {
                                width: 0.15rem;
                                height: 0.3rem;
                                background: #F5F7FA;
                                border-radius: 0.15rem 0 0 0.15rem;
                            }
                        }
                        .ticketBtn {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 0.32rem 0.32rem;
                            .left {
                                font-size: 0.26rem;
                                color: #333333;
                                span {
                                    margin-left: 0.2rem;
                                    font-size: 0.26rem;
                                    color: #999999;
                                }
                            }
                            .right {
                                button {
                                    width: 1.58rem;
                                    height: 0.5rem;
                                    background: #409EFF;
                                    color: #fff;
                                    border-radius: 0.3rem;
                                    padding: 0;
                                    font-size: 0.24rem;
                                    line-height: 0.5rem;
                                }
                            }
                        }
                    }
                }
                .noData{
                    padding-top: 2.8rem;
                    display: flex;
                    justify-content: center;
                    img{
                        width: 3rem;
                        height: 2.5rem;
                    }
                }
            }
        }
        .checkMsg{
            padding: 0.24rem 0;
            text-align: center;
            color: #4995EC;
            font-size: 0.28rem;
        }
    }
</style>